module.exports = __webpack_public_path__ + "img/Group 1437255028 (2).9382aa88.png";